import React, { ReactNode, useMemo } from 'react';
import { MFOutlet } from '@im/ui-lib/mf-utils';
import {
  EnvVars,
  buildConfigContext,
  createBuildConfig,
} from './build-config-context';

type Props = {
  children: ReactNode;
  envVars: EnvVars;
  mfOutlets: MFOutlet[];
};

export function BuildConfigProvider(props: Props) {
  const { children, envVars = {}, mfOutlets } = props;

  const buildConfig = useMemo(() => {
    return createBuildConfig(envVars, mfOutlets);
  }, [envVars, mfOutlets]);

  const { Provider } = buildConfigContext;
  return <Provider value={buildConfig}>{children}</Provider>;
}
